
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from "vue-lazyload"
Vue.use(VueLazyload)
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "../src/assets/image/loading.gif",
  loading: "../src/assets/image/loading.gif",
  attempt: 1
})

// Install BootstrapVue

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.config.productionSourceMap = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
